import i18next from 'i18next';
import * as Yup from 'yup';

export const timetableBlockSchema = Yup.object().shape({
  start: Yup.date().required(i18next.t('validation.common.startRequired')),
  end: Yup.date().required(i18next.t('validation.common.endRequired')),
  timetables: Yup.array().required(i18next.t('validation.timetableBlock.timetablesRequired')),
});
